'use strict';

// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = require('is-callable');



//////////////////
// WEBPACK FOOTER
// ./~/function.prototype.name/~/es-abstract/2020/IsCallable.js
// module id = 2723
// module chunks = 0